//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'BenefitsCardItem',
  props: {
    benefitsItem: Object
  }
};